export default __webpack_public_path__ + "static/media/networking.15820443.jpg";